import React from 'react'
import { TableCell, TableSortLabel } from '@material-ui/core'

export const SortableTableCell = ({ id, currentOrderById, handleSortRequest, children, className }) => {
  const [order, setOrder] = React.useState('asc')

  const flippedOrder = () => (order == 'desc' ? 'asc' : 'desc')
  const flip = () => setOrder(flippedOrder())

  const handleClick = id => event => {
    handleSortRequest(id, flippedOrder())
    flip()
  }

  return (
    <TableCell className={`${className} clickable`} key={id} sortDirection={currentOrderById === id ? order : false}>
      <TableSortLabel active={currentOrderById === id} direction={order} onClick={handleClick(id)}>
        {children}
      </TableSortLabel>
    </TableCell>
  )
}
